import Vidim from 'vidim';
import helpers from './helpers.js';

/*
===================================================================
Video Backgrounds on masthead
===================================================================
*/
export default (function () {
  return {
    init() {
      let bgVideo;
      const pauseButton = document.querySelectorAll('.js-masthead-video-pause');
      const playButton = document.querySelectorAll('.js-masthead-video-play');
      const vidMastheads = document.querySelectorAll('.js-masthead-player[data-yt-id], .js-masthead-player[data-mp4]');

      if (vidMastheads.length === 0) return;

      helpers.forEach(vidMastheads, (i, el) => {
        const poster = el.getAttribute('data-poster');

        el.insertAdjacentHTML('afterbegin', '<div class="masthead__bg"></div>');
        const bg = el.querySelector('.masthead__bg');

        if (el.getAttribute('data-yt-id') !== null) {
          bgVideo = new Vidim(bg, {
            type: 'YouTube',
            src: el.getAttribute('data-yt-id'),
            poster,
            autoplay: true,
            loop: true,
            muted: true,
            overlayClass: 'masthead__mask',
            showPosterBeforePlay: true,
          });
        } else if (el.getAttribute('data-mp4')) {
          bgVideo = new Vidim(bg, {
            src: [
              {
                type: 'video/mp4',
                src: el.getAttribute('data-mp4'),
              },
            ],
            poster,
            autoplay: true,
            loop: true,
            muted: true,
            overlayClass: 'masthead__mask',
            showPosterBeforePlay: true,
          });
        }

        bgVideo.addEventListener('play', (e) => {
          helpers.addClass(el, 'is-playing');
        });

        pauseButton.forEach((btn) => {
          btn.addEventListener('click', (e) => {
            const parent = e.currentTarget.parentElement;
            const mastheadVideoPlayer = parent.querySelector('.js-masthead-player');
            const mastheadPlayBtn = parent.querySelector('.js-masthead-video-play');

            if(mastheadVideoPlayer.getAttribute('data-mp4')) {
              const video = mastheadVideoPlayer.querySelector('video');
              video.pause();
            } else {
              const iFrame = mastheadVideoPlayer.querySelector('iframe');
			  iFrame.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
            }

            e.currentTarget.classList.remove('is-visible');
            e.currentTarget.classList.add('is-hidden');
            mastheadPlayBtn.classList.remove('is-hidden');
            mastheadPlayBtn.classList.add('is-visible');
          });
        });

        playButton.forEach((btn) => {
          btn.addEventListener('click', (e) => {
			  const parent = e.currentTarget.parentElement;
			  const mastheadVideoPlayer = parent.querySelector('.js-masthead-player');
			  const mastheadPauseBtn = parent.querySelector('.js-masthead-video-pause');

			  if(mastheadVideoPlayer.getAttribute('data-mp4')) {
              const video = mastheadVideoPlayer.querySelector('video');
              video.play();
			  } else {
              const iFrame = mastheadVideoPlayer.querySelector('iframe');
              iFrame.contentWindow.postMessage('{"event":"command","func":"playVideo","args":""}', '*');
			  }

			  e.currentTarget.classList.remove('is-visible');
			  e.currentTarget.classList.add('is-hidden');
			  mastheadPauseBtn.classList.remove('is-hidden');
			  mastheadPauseBtn.classList.add('is-visible');
          });
		  });
      });
    },
  };
})();
